export const validate = (values, validationRules) => {
    const errors = {};
    validationRules.forEach(rule => {
        errors[rule.field] = [];
    });

    values.forEach((value, index) => {
        const rowNum = index + 1;

        validationRules.forEach(rule => {
            const fieldValue = value[rule.field];
            let isInvalid = false;

            if (rule.type === 'string') {
                isInvalid = !fieldValue || fieldValue.trim() === "";
            } else if (rule.type === 'array') {
                isInvalid = !fieldValue || fieldValue.length === 0;
            } else if (rule.type === 'number') {
                isInvalid = fieldValue === undefined || fieldValue === null || isNaN(fieldValue);
            } else if (rule.type === 'boolean') {
                isInvalid = fieldValue === undefined || fieldValue === null;
            }

            if (rule.validate && typeof rule.validate === 'function') {
                isInvalid = !rule.validate(fieldValue, value);
            }

            if (isInvalid) {
                errors[rule.field].push(`${rule.message} on row ${rowNum}`);
            }
        });
    });

    return errors;
};

export const hasValidationErrors = (errors) => {
    return Object.values(errors).some(fieldErrors => fieldErrors.length > 0);
};

export const getInitialErrors = (validationRules) => {
    const errors = {};
    validationRules.forEach(rule => {
        errors[rule.field] = [];
    });
    return errors;
};

